import {
    DEALERDELETEDSR_SUCCESS,
    DEALERDELETEDSR_FAILED,
    RESET_DEALERDELETEDSR,
    LOADING_DEALERDELETEDSR,
    NETWORK_ERROR_DEALERDELETEDSR
} from "../types/index";
import { dealerServices } from "../../config/axios";


const resetDealerDeleteDsrList = () => {
    return { type: RESET_DEALERDELETEDSR };
};


const dealerDeleteDsr = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERDELETEDSR });
    await dealerServices
        .post("deleteDsr", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerDeleteDsrsuccess(res.data));
                    break;
                default:
                    dispatch(dealerDeleteDsrFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERDELETEDSR,
                payload: err
            });
        });
};

function dealerDeleteDsrsuccess(data) {
    return {
        type: DEALERDELETEDSR_SUCCESS,
        payload: data
    };
}
function dealerDeleteDsrFailed(data) {
    return {
        type: DEALERDELETEDSR_FAILED,
        payload: data
    };
}
export { resetDealerDeleteDsrList, dealerDeleteDsr }